import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { PartnerService } from '../services/partner.service';
import {
  fetchPartnerList,
  loadedPartnerList,
  failedPartnerList,
  updatePartnerListFilter,
} from './partner-list.actions';
import { selectPartnerListFilter } from './partner-list.selector';

@Injectable()
export class PartnerListEffect {
  loadPartnerList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchPartnerList),
      switchMap(({ filter }) =>
        this.partnerService.getPartnerList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedPartnerList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedPartnerList();
            }
          }),
          catchError(() => of(failedPartnerList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updatePartnerListFilter),
      concatLatestFrom(() => this.store.select(selectPartnerListFilter)),
      switchMap(([action, prevFilter]) =>
        of(fetchPartnerList({ filter: { ...prevFilter, ...action.filter } }))
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly partnerService: PartnerService
  ) {}
}
